"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iMetadata = exports.iMetadataWithoutUuid = exports.iMetadataOption = exports.iMetaTypeValue = exports.iMetaTypeValuePrimitive = exports.iMetaType = exports.MetaTypePrimitive = exports.SUBPROJECT = exports.FILES_LIST = exports.HIDE_ON_FILES_LIST = exports.EDITABLE = exports.REQUIRED = exports.MANDATORY = exports.iReferenceMeta = void 0;
const t = require("io-ts");
exports.iReferenceMeta = t.intersection([
    t.interface({
        id: t.number
    }),
    t.partial({
        name: t.string,
        value: t.string
    })
]);
exports.MANDATORY = (1 << 0);
exports.REQUIRED = (1 << 1);
exports.EDITABLE = (1 << 2);
exports.HIDE_ON_FILES_LIST = (1 << 3);
exports.FILES_LIST = (1 << 4);
exports.SUBPROJECT = (1 << 5);
exports.MetaTypePrimitive = {
    'text': null,
    'number': null,
    'textarea': null,
    'checkbox': null,
    'day': null,
    'time': null,
    'datetime': null,
    'select': null,
    'dependant-select': null,
    'radio': null,
    'reference': null
};
exports.iMetaType = t.keyof(Object.assign(Object.assign({}, exports.MetaTypePrimitive), { reference: null }));
exports.iMetaTypeValuePrimitive = t.union([t.string, t.number, t.boolean, t.null]);
exports.iMetaTypeValue = t.union([exports.iMetaTypeValuePrimitive, exports.iReferenceMeta]);
const _iMetadataOption = t.intersection([
    t.interface({
        name: t.string,
        order: t.number
    }),
    t.partial({
        id: t.number,
        value: exports.iMetaTypeValue,
        options: t.array(t.any),
        references: t.union([t.null, t.number])
    })
]);
exports.iMetadataOption = t.clean(_iMetadataOption);
const _iMetadataWithoutUuid = t.intersection([
    t.interface({
        type: exports.iMetaType,
        required: t.boolean,
        name: t.string
    }),
    t.partial({
        id: t.number,
        options: t.array(exports.iMetadataOption),
        parent: t.number,
        submeta: t.any
    })
]);
exports.iMetadataWithoutUuid = t.clean(_iMetadataWithoutUuid);
const _iMetadata = t.intersection([
    exports.iMetadataWithoutUuid,
    t.interface({
        bitField: t.number,
        order: t.number,
        editable: t.boolean,
        hideOnFileList: t.boolean,
        identifier: t.string,
        mandatory: t.boolean
    })
]);
exports.iMetadata = t.clean(_iMetadata);
//# sourceMappingURL=customMeta.js.map